var map = {
	"./ActionMenu.js": 464,
	"./Actions.js": 466,
	"./Caret.js": 467,
	"./DocumentView.js": 479,
	"./DropdownMenuItem.js": 480,
	"./FluentBtn.js": 481,
	"./Search.js": 468,
	"./Switch.js": 469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;